// extracted by mini-css-extract-plugin
export default {"button":"Pages_button__wqfcq"};